export default "__VITE_ASSET__BLLE0SEe__"